import { Toolbar, ToolbarProps } from '@material-ui/core';
import { FC } from 'react';
import styled from 'styled-components';

export const PageToolbar: FC<ToolbarProps> = styled(Toolbar)`
  padding: 16px 32px;
`;
